export default {
  label: "Configurator",
};
